export const UPSERT_ROLE_ATTRIBUTES_CONSTANT = {
  name: {
    type: 'text',
    key: 'name',
    label: 'Role Name',
  },
  roleType: {
    type: 'text',
    key: 'role_type',
    label: 'Role Type',
  },
  slug: {
    type: 'text',
    key: 'slug',
    label: 'Slug',
  },
  description: {
    type: 'text',
    key: 'description',
    label: 'Description',
  },
} as const;

export const ROLE_TYPE = [
  { value: 'PLATFORM', label: 'Platform' },
  { value: 'PARTNER', label: 'Partner' },
];
